import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormArray, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

import { MatColors } from '@fuse/mat-colors';

import { AuthService } from 'app/auth.service';
@Component({
    selector     : 'container-modal-form-dialog',
    templateUrl  : './container-modal-form.component.html',
    styleUrls    : ['./container-modal-form.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class ContainerModalFormDialogComponent implements OnInit
{
    action: string;
    checkNum = 0;
    containerData;
    containerModalForm = this._formBuilder.group({
        type: [null],
        volume: this._formBuilder.array([
            this._formBuilder.group({
                quantity: [0, Validators.required],
                name: ['20DC']
            }),
            this._formBuilder.group({
                quantity: [0, Validators.required],
                name: ['40DC']
            }),
            this._formBuilder.group({
                quantity: [0, Validators.required],
                name: ['40HC']
            }),
        ])
    });
    dialogTitle: string;
    unit: any[];
    

    /**
     * Constructor
     *
     * @param {MatDialogRef<ContainerModalFormDialogComponent>} matDialogRef
     * @param _data
     * @param {FormBuilder} _formBuilder
     */
    constructor(
        public matDialogRef: MatDialogRef<ContainerModalFormDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private _data: any,
        private _formBuilder: FormBuilder,
        private authService: AuthService,
    )
    {
        this.action = _data.action;
        this.unit =  _data.unit.filter(item => item.p_group == 1);
        
        if ( this.action === 'edit' ){
            this.dialogTitle = 'Edit Container';
        } else {
            this.dialogTitle = 'Volume';
        }
    }

    ngOnInit(): void{
        this.containerModalForm.controls.volume.valueChanges.subscribe(val => {
            this.checkNum = 0;
            for (let i = 0; i < val.length; i++){
                this.checkNum += val[i].quantity;
            }
        });
    }

    get unitAdd(): FormArray {
        return this.containerModalForm.get('volume') as FormArray;
    }
    addUnit(type){
        let check = true;
        for(let i = 0; i < this.unitAdd.value.length; i++){
          if(this.unitAdd.value[i].name == type.code){
            check = false;
            break;
          }
        }
        if(check){
          this.unitAdd.push(this._formBuilder.group({quantity: 1, name: type.code}));
        } else {
          alert("This container type is exist");
        }
    }
    removeUnit(i){
        this.unitAdd.removeAt(i);
    }
}

